import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mev" }
const _hoisted_2 = {
  key: 1,
  class: "mev__vset-date med-date"
}
const _hoisted_3 = ["onMouseenter", "onClick"]
const _hoisted_4 = {
  key: 2,
  class: "mev__vset-empty"
}
const _hoisted_5 = {
  key: 2,
  class: "mev__date med-date"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_native_input = _resolveComponent("native-input")!
  const _component_loading_skeleton = _resolveComponent("loading-skeleton")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_mosta_tree_select = _resolveComponent("mosta-tree-select")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ([0, 1, 2].includes(_ctx.parameterValueType))
      ? (_openBlock(), _createBlock(_component_native_input, {
          key: 0,
          class: "mev__input",
          "show-border": true,
          "edit-on-click": true,
          "clear-hotkey": true,
          "disabled-field": _ctx.disable,
          "model-value": _ctx.theModel.stringValue,
          "external-warning": !!_ctx.numberWarning,
          "external-warning-text": _ctx.numberWarning,
          onLiveValue: _cache[0] || (_cache[0] = (val) => { _ctx.liveText = val; }),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => { _ctx.theModel.stringValue = val; })
        }, null, 8, ["disabled-field", "model-value", "external-warning", "external-warning-text"]))
      : (_ctx.parameterValueType === 4)
        ? (_openBlock(), _createBlock(_component_mosta_tree_select, {
            key: 1,
            ref: "vsetSelect",
            class: "mev__vset",
            "display-text": _ctx.valueSetDisplayText,
            placeholder: _ctx.vsetTitle || _ctx.$t('values_set'),
            disable: _ctx.disable,
            "show-free-input": _ctx.canCreateValue,
            "free-input-tooltip": _ctx.$t('add_value'),
            "onUpdate:search": _cache[2] || (_cache[2] = (val) => { _ctx.searchText = val; }),
            onFreeInputPressed: _ctx.createValueFromSearch,
            onKeyEnter: _ctx.onValueSetEnter,
            onOpen: _ctx.scheduleTruncationCheck
          }, {
            default: _withCtx(() => [
              (_ctx.vsetLoading)
                ? (_openBlock(), _createBlock(_component_loading_skeleton, { key: 0 }))
                : _createCommentVNode("", true),
              (!_ctx.vsetLoading && _ctx.parameterSetValueType === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_VueDatePicker, {
                      utc: "preserve",
                      timezone: "Europe/Moscow",
                      locale: _ctx.$i18n.locale,
                      teleport: true,
                      clearable: false,
                      "enable-time-picker": false,
                      format: _ctx.formatDate,
                      "text-input": _ctx.textInputOptions,
                      "alt-position": _ctx.positionDateMenu,
                      "auto-apply": true,
                      "action-row": { showSelect: false, showCancel: false, showPreview: false },
                      "model-value": null,
                      "onUpdate:modelValue": _ctx.createDateValue
                    }, null, 8, ["locale", "format", "text-input", "alt-position", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.vsetLoading ? [] : _ctx.vsetFilteredOptions), (opt) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: opt.Id,
                  ref_for: true,
                  ref: (el) => _ctx.setOptionRef(opt.Id, el),
                  class: _normalizeClass(["mev__vset-item", { 'mev__vset-item--active': _ctx.isValueSelected(opt) }]),
                  onMouseenter: ($event: any) => (_ctx.checkTruncation(opt.Id)),
                  onClick: ($event: any) => (_ctx.selectValue(opt))
                }, [
                  _createTextVNode(_toDisplayString(opt.Name) + " ", 1),
                  _createVNode(_component_q_tooltip, {
                    "no-parent-event": !_ctx.truncatedOptions[opt.Id],
                    delay: 300,
                    anchor: "top left",
                    self: "bottom left",
                    offset: [0, 0],
                    class: "mev-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(opt.Name), 1)
                    ]),
                    _: 2
                  }, 1032, ["no-parent-event"])
                ], 42, _hoisted_3))
              }), 128)),
              (!_ctx.vsetLoading && !_ctx.vsetFilteredOptions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('nothing_found')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["display-text", "placeholder", "disable", "show-free-input", "free-input-tooltip", "onFreeInputPressed", "onKeyEnter", "onOpen"]))
        : (_ctx.parameterValueType === 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_VueDatePicker, {
                utc: "preserve",
                timezone: "Europe/Moscow",
                locale: _ctx.$i18n.locale,
                teleport: true,
                clearable: false,
                disabled: _ctx.disable,
                "enable-time-picker": false,
                format: _ctx.formatDate,
                "text-input": _ctx.textInputOptions,
                "alt-position": _ctx.positionDateMenu,
                "auto-apply": true,
                "action-row": { showSelect: false, showCancel: false, showPreview: false },
                modelValue: _ctx.dateModel,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateModel) = $event))
              }, null, 8, ["locale", "disabled", "format", "text-input", "alt-position", "modelValue"]),
              _createVNode(_component_q_tooltip, {
                "no-parent-event": !!_ctx.dateModel,
                delay: 300,
                anchor: "top left",
                self: "bottom left",
                offset: [0, 0],
                class: "mev-tooltip"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('field_cannot_be_empty')), 1)
                ]),
                _: 1
              }, 8, ["no-parent-event"])
            ]))
          : (_ctx.parameterValueType === 3)
            ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                key: 3,
                class: "mev__bool",
                disable: _ctx.disable,
                modelValue: _ctx.theModel.checkBoxModel,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.theModel.checkBoxModel) = $event)),
                label: _ctx.$t('yes_label') + ' / ' + _ctx.$t('no_label')
              }, null, 8, ["disable", "modelValue", "label"]))
            : _createCommentVNode("", true)
  ]))
}